<template>
  <div id="app">
    
  
      <!-- <login-page/> -->
      <navbar/>
        <router-view/>
      <Footer/>
    
    <!-- <router-view/> -->
  </div>
</template>

<script>


import Navbar from './components/Navbar.vue'

import Footer from './components/Footer.vue'

export default {
  name : 'App',
  components : {
    // LoginPage,
    Navbar,
    // Home,
    // ListPuskesmas,
    // PuskesmasDetail,
    Footer,
    // Statistik

  }
}
</script>

<style>

</style>
